module.exports = __webpack_public_path__ + "static/media/2.5073e272.jpeg";